<template>
  <div class="col-12">
    <div class="now-loading-overlay" v-if="correctLoading">
      <div class="overlay-content">
        <div class="d-flex justify-content-center align-items-center">
          <div>
            <p v-if="!reloadStop">
              <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><br>
              ただいま登録手続き中です。QRコードが表示されるまでタブを閉じないでください。<br>
              We are currently in the registration process. Do not close the tab until you see the QR code.
            </p>
            <p v-html="timeoutMessage"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- 申し込み内容の確認 -->
        <div class="help-block">
          {{ $t($t('message.step4_subtext')) }}
        </div>
        <!-- <div>{{$t('次の画面で『レンタルNo』を必ず確認してください！')}}</div> -->
        <div v-if="!Object.keys(errors).length">{{ $t('次の画面で『レンタルNo』を必ず確認してください！') }}</div>
        <div class="text-danger" style="font-size: 1.4rem;" v-if="errors['willVisit'] === '受付時間帯指定を変更してください'">
          {{ $t('『受付時間帯』を選択し、申込ボタンをクリックして、次の画面でレンタルNoを確認してください！') }}
        </div>
        <div class="text-danger" style="font-size: 1.4rem;" v-if="errors['outOfStock']">{{ $t(errors['outOfStock']) }}
        </div>
        <div class="text-danger" style="font-size: 1.4rem;" v-if="errors['willVisit'] === '受付時間帯指定を変更してください'">
          {{ $t('この時間帯は受付人数が最大に達しています') }}
        </div>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col">
            {{ $t('message.rentalDate') }}
          </div>
          <div class="col text-left">
            {{ this.$root.$store.state.rentalDate }}
          </div>

          <template
              v-if="this.willVisitOff === false && (!this.$root.$route.query.dev || this.$root.$route.query.dev == undefined || this.$root.$route.query.dev !== 'tab')">
            <div class="w-100 mt-2"></div>
            <div class="col">
              {{$t(this.texts.willVisit)}}
            </div>
            <div class="col text-left">
              <template v-if="!errors['willVisit'] && showTimeSelect === false">
                {{ willVisitFrom }}
                <span v-if="this.texts.codeWillVisit === '02'">
                {{ $t('message.receiveTimeTo') }}
                {{ willVisitTo }}
                </span>
              </template>
              <template v-if="errors['willVisit'] || showTimeSelect">
                <div class="form-group" v-if="Object.keys(times).length > 0">
                  <select class="form-control" @input="updateWillVisit">
                    <option v-for="(v, i) in times" :key="'times-' + i" :value="i"
                            :selected="willVisit === i">{{ v }}
                    </option>
                  </select>
                  {{ $t('message.receiveTimeTo') }}
                  {{ willVisitTo }}
                </div>
              </template>
              <div class="text-danger">{{ $t(errors['willVisit']) }}</div>
            </div>
          </template>
          <div class="w-100 mt-2"></div>
          <div class="col">
            {{ $t('message.reserve_term') }}
          </div>
          <div class="col text-left">
            {{ $t('message.reserveTerm' + this.$root.$store.state.reserve_term) }}
          </div>

          <div class="w-100 mt-2"></div>
          <div class="col">
            {{ $t('message.idcard') }}
          </div>
          <div class="col text-left">
            {{ $t('message.idcard' + this.$root.$store.state.idcard) }}
          </div>

          <div class="w-100 mt-2"></div>
          <div class="col">
            {{ $t('携帯電話番号') }}
          </div>
          <div class="col text-left">
            {{ this.$root.$store.state.tel }}
          </div>

          <div class="w-100 mt-2"></div>
          <template v-if="this.$root.$store.state.privacy === 1">
            <div class="col">
              {{ $t('message.privacy') }}
            </div>
            <div class="col">
              <i class="fas fa-check"></i> {{ $t('message.privacy_label') }}
            </div>

            <div class="w-100 mt-2"></div>
            <div class="col">
              {{ $t('message.zip') }}
            </div>
            <div class="col text-left">
              {{ this.$root.$store.state.zip }}
            </div>

            <div class="w-100 mt-2"></div>
            <div class="col">
              {{ $t('message.address') }}
            </div>
            <div class="col text-left">
              {{ this.$root.$store.state.address }}
            </div>
          </template>
          <template v-else>
            <template v-if="this.$root.$store.state.address">
              <div class="w-100 mt-2"></div>
              <div class="col">
                {{ $t('message.address') }}
              </div>
              <div class="col text-left">
                {{ this.$root.$store.state.address }}
              </div>
            </template>
            <template v-if="this.$root.$store.state.address1 || this.$root.$store.state.address2">
              <div class="w-100 mt-2"></div>
              <div class="col">
                {{ $t('message.address') }}
              </div>
              <div class="col text-left">
                {{ this.$root.$store.state.address1 }}
                {{ this.$root.$store.state.address2 }}
              </div>
            </template>
          </template>

        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="row">
          <div class="col">
            {{ $t('message.membersCount') }}
          </div>
          <div class="col text-left">
            {{ this.$_.size(this.$root.$store.state.members) }}
          </div>
        </div>
        <div class="row">
          <div class="col">
            <hr>
          </div>
        </div>

        <div class="row mt-2 border p-1 bg-light" v-for="(member, index) in this.$root.$store.state.members"
             :key="'member-'+index">
          <div class="col-12 col-md-6 p-1">
            <strong class="mr-2">
              {{ member.last_name }} {{ $t(member.first_name) }}
            </strong>
          </div>
          <div class="col-12 col-md-6 p-1">
            <div class="text-left ml-4">
              <small>
                <template v-if="$root.serviceSetting.input_type_age === 'button'">
                  <span class="text-info">{{$t($t('message.age' + member.age))}}</span>&nbsp;/
                </template>
                <template v-else>
                  <span class="text-info">{{member.age}} {{$t('歳')}}</span>&nbsp;/
                </template>
                <span class="text-info">{{ member.height }} cm</span>&nbsp;/
                <span class="text-info">{{ shoeFormatted(member.shoe) }}</span>&nbsp;
              </small>
            </div>
            <div class="text-left ml-4">
              [{{ $t($t('message.item' + member.item.slice(0, 1).toUpperCase() + member.item.slice(1))) }}
              {{ $t(member.itemCategoryName) }}]
              <div v-for="i in member.rentalItems" :key="'rental-item-' + i.item">{{ $t(i.name) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
                <span class="design2" style="font-size: 2.5rem;font-weight: bold;display: inline-block;margin-bottom: 0.5rem">
                  {{ $t('金額合計') }} ￥{{ priceTotal }}
                </span>
                <span v-if="this.enableV && this.feePrice > 0" data-testid="step4_fee_note"> （{{ $t('取置予約には別途' + $t(feeNameKey, 'ja') + 'が掛かります') }}） </span>
        <br>
        <!-- todo: optionで表示を分岐 -->
        <template v-if="this.$root.$route.query.ui === '1'">
          <span v-if="this.$root.serviceSetting.reserve_step4_price_footer.value && this.$root.$route.query.type === 'V'">
          </span>
        </template>
        <template v-else-if="this.$root.$route.query.ui === '2' && this.$root.$route.query.type === 'V'">
          <!-- -->
        </template>
        <template v-else>
          <span v-if="this.$root.serviceSetting.reserve_step4_price_footer.value">
                  {{ $t(this.$root.serviceSetting.reserve_step4_price_footer.value) }}
          </span>
        </template>
        <!-- /optionで表示を分岐 -->

      </div>
    </div>
    <div class="row mt-4"
         v-if="this.$root.serviceSetting.enable_membership.value === '1' && this.$root.$route.query.dev !== 'tab'">
      <div class="col-12">
        <div class="form-box form-box-gray">
          <label data-testid="step4_repeater_register" @click="toggleSaveMembership">
            <i
                v-if="this.$root.$store.state.saveMembership === true"
                class="fas fa-check-square checked text-success fa-2x d-inline-block"
                style="display: table-cell;vertical-align: middle"/>
            <i
                v-else
                class="far fa-square text-gray-light fa-2x d-inline-block"
                style="display: table-cell;vertical-align: middle"/>
            &nbsp;
            <span v-html="$t('レンタル会員登録する(既に登録されている場合はこの申し込みで更新します)')" />
          </label>
        </div>
      </div>
    </div>
    <!-- レンタルギア補償サービス(申込確定直前・enable_item_insurance の施設のみ) -->
    <div class="row mt-4"
         v-if="$root.serviceSetting.enable_item_insurance && $root.serviceSetting.enable_item_insurance.value === 'true'">
      <div class="col-12">
        <div class="form-box">
          <p class="text-danger text-center font-weight-bold mb-2"
             style="font-size: 1.1rem;">{{ $t('message.item_insurance_heading') }}</p>
          <label class="insurance-label" data-testid="option_gear_insurance"
                 :data-teststate="this.$root.$store.state.itemInsurance === true ? 'checked' : 'selectable'"
                 @click="toggleItemInsurance">
            <i
                v-if="this.$root.$store.state.itemInsurance === true"
                class="fas fa-check-square checked text-success fa-2x d-inline-block"
                style="display: table-cell;vertical-align: middle"/>
            <i
                v-else
                class="far fa-square text-gray-light fa-2x d-inline-block"
                style="display: table-cell;vertical-align: middle"/>
            &nbsp;
            <span v-html="$t('message.item_insurance_label')" />
          </label>
          <p class="text-muted mb-0" style="font-size: 0.9em;"
             v-html="$t('message.item_insurance_note', { price: insurancePrice })"></p>
        </div>
      </div>
    </div>
    <!-- /レンタルギア補償サービス -->
    <div v-if="this.$root.serviceSetting.prepaid_method.value === '' && errors['stripe'] === 'stripe_error'">
      <div class="text-danger" style="font-size: 1.4rem;">{{ $t(stripeError.status) }}</div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <!-- 通常取り置き -->
        <button v-if="this.enableS" data-testid="step4_submit" data-teststate="onsite" @click="correctS()"
                class="btn btn-primary btn-h-6 design4 Rental_cv4 btn-3d" style="min-width: 120px;min-height: 70px;"
                :disabled="this.nowLoading === true">
          <i class="fas fa-check"></i>
          <!-- ui-1 -->
          <template v-if="this.$root.$route.query.ui === '1'">
            <template v-if="!this.enableV && isRad">
              {{ $t('この内容で申し込む') }}
            </template>
            <template v-else>
              {{ $t('この内容で申し込む') }}
            </template>
          </template>
          <!-- ui-2 -->
          <template v-if="this.$root.$route.query.ui === '2'">
            <template v-if="isRad">
              {{ $t('お申し込み') }}
            </template>
            <template v-if="!isRad">
              &nbsp;{{ $t('取置予約') }}<br>
              <small v-if="this.feePrice > 0">＋{{ $t(feeNameKey) }} ￥{{ numPeople * feePrice }}</small>
            </template>
          </template>
          <!-- その他 -->
          <template v-if="this.$root.$route.query.ui != 1 && this.$root.$route.query.ui != 2 ">
            {{ $t('来店時決済') }}<br>
          </template>
          <i class="fas fa-arrow-right"></i>
        </button>

        <div class="text-danger" style="font-size: 1.4rem;" v-if="errors['timeLimit']">{{ $t(errors['timeLimit']) }}
        </div>

        <!-- 事前決済取り置き -->
        <!-- 0円のVは事前決済(カード登録)せずに申し込む #269 -->
        <button v-if="prepaidLimit() && this.enableV && isZeroTotal" data-testid="step4_submit" data-teststate="prepaid_zero" class="btn btn-primary btn-h-6 ml-4 design4 Rental_cv4pld btn-3d"
                style="min-width: 120px" :disabled="this.nowLoading === true" @click="correctV()">
          <i class="fas fa-check"></i> {{ $t('この内容で申し込む') }}
          <i class="fas fa-arrow-right"></i>
        </button>

        <button v-if="prepaidLimit() && this.enableV && !isZeroTotal && this.$root.serviceSetting.prepaid_method.value === null" data-testid="step4_submit" data-teststate="prepaid_none" class="btn btn-primary btn-h-6 ml-4 design4 Rental_cv4pld btn-3d"
                style="min-width: 120px" :disabled="this.nowLoading === true" @click="correctV()">
          <i class="fas fa-check"></i> &nbsp;{{ $t('取置予約') }}<br>
          <small v-if="this.feePrice > 0">＋{{ $t(feeNameKey) }} ￥{{ numPeople * feePrice }}</small>
          &nbsp;
          <i class="fas fa-arrow-right"></i>
        </button>

        <button v-if="prepaidLimit() && this.enableV && !isZeroTotal && this.$root.serviceSetting.prepaid_method.value === 'STRIPE'" data-testid="step4_submit" data-teststate="prepaid_stripe" class="btn btn-primary btn-h-6 ml-4 design4 Rental_cv4pld btn-3d"
                data-toggle="modal" data-target="#modal1" style="min-width: 120px" :disabled="this.nowLoading === true">
          <i class="fas fa-check"></i> {{ $t('取置予約') }}<br>
          <small v-if="this.feePrice > 0">＋{{ $t(feeNameKey) }} ￥{{ numPeople * feePrice }}</small>
          <i class="fas fa-arrow-right"></i>
        </button>
        <button v-if="prepaidLimit() && this.enableV && !isZeroTotal && this.$root.serviceSetting.prepaid_method.value === 'SB_PAYMENT'" data-testid="step4_submit" data-teststate="prepaid_sbps" class="btn btn-primary btn-h-6 ml-4 design4 Rental_cv4pld btn-3d"
                @click="openPrepaidModal" style="min-width: 120px" :disabled="this.nowLoading === true">

          <template v-if="this.$root.serviceSetting.User.id === '1' && this.$parent.$i18n.locale === 'ja'">
            <i class="fas fa-check"></i> 事前決済画面へ<br>進む
          </template>
          <template v-else-if="this.$root.serviceSetting.User.id === '2' ">
            <i class="fas fa-check"></i> {{ $t('事前決済') }}<br>
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <i class="fas fa-check"></i> {{ $t('事前決済') }}<br>
            <small v-if="this.feePrice > 0">＋{{ $t(feeNameKey) }} ￥{{ numPeople * feePrice }}..</small>
            <i class="fas fa-arrow-right"></i>
          </template>

        </button>

        <button v-if="prepaidLimit() && this.enableV && !isZeroTotal && this.$root.serviceSetting.prepaid_method.value === 'SQUARE'" data-testid="step4_submit" data-teststate="prepaid_square" class="btn btn-primary btn-h-6 ml-4 design4 Rental_cv4pld btn-3d"
                @click="openSquareCardModal" style="min-width: 120px" :disabled="this.nowLoading === true">
          <i class="fas fa-check"></i> {{ $t('事前決済') }}<br>
          <small v-if="this.feePrice > 0">＋{{ $t(feeNameKey) }} ￥{{ numPeople * feePrice }}</small>
          <i class="fas fa-arrow-right"></i>
        </button>

        <template v-if="!isTab">
          <div v-if="!prepaidLimit() && this.enableV">※{{ $t(this.$root.serviceSetting.limittime_blocked_str.value) }}</div>
        </template>
      </div>
      <div class="col-12 mt-4 mt-md-0">
        <div class="row mt-4">
          <div class="col-12">
            <strong v-if="!Object.keys(errors).length" class="text-danger"
                    style="font-size: 1.3rem;">

              <template v-if="this.$root.serviceSetting.User.id === '1' && this.$root.$i18n.locale === 'ja'">
                <span style="font-size: 2rem">
                ⑤の登録完了画面で<br>必ずレンタルNo.を確認してください！
                </span>
              </template>
              <template v-else>
                {{ $t('次の画面で『レンタルNo』を必ず確認してください！') }}
              </template>
            </strong>
            <strong v-if="errors['willVisit'] === '受付時間帯指定を変更してください'" class="text-danger"
                    style="font-size: 1.3rem;">{{ $t('『受付時間帯』を選択し、申込ボタンをクリックして、次の画面でレンタルNoを確認してください！') }}</strong>
          </div>
        </div>
        <!-- レンタルギア補償サービスの説明(enable_item_insurance の施設のみ・キャンセル料注記と同じ表示) -->
        <div class="row mt-4 mb-3"
             v-if="$root.serviceSetting.enable_item_insurance && $root.serviceSetting.enable_item_insurance.value === 'true'">
          <div class="col text-left">
            <small>{{ $t('message.item_insurance_about_title') }}<br><span v-html="$t('message.item_insurance_about')"></span></small>
          </div>
        </div>
        <!-- /レンタルギア補償サービスの説明 -->
        <div class="row">
          <div class="col text-left">
            <small v-html="noticeReserveConfirmMessage"></small>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal-payment" tabindex="-1" role="dialog" aria-labelledby="label1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title ml-3">{{ $t('ご予約詳細') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row mt-2 border bg-white" v-for="(member, index) in this.$root.$store.state.members"
                 :key="'member-'+index">
              <div class="col p-1">
                <strong class="mr-2">{{ member.last_name }} {{ member.first_name }}<template v-if="$root.$i18n.locale === 'ja'"> {{ $t('様') }}</template></strong>
                <div>
                  <small v-if="feePrice > 0">
                    <span class="text-info">￥{{ calcAmount(member) }}     +    {{ $t(feeNameKey) }}¥{{ feePrice }}</span>
                  </small>
                </div>
              </div>
              <div class="col p-1">
                <div class="text-left ml-4">
                  <small>
                    <span class="text-info">{{ $t($t('message.age' + member.age)) }}</span>&nbsp;/
                    <span class="text-info">{{ member.height }} cm</span>&nbsp;/
                    <span class="text-info">{{ shoeFormatted(member.shoe) }}</span>&nbsp;
                  </small>
                </div>
                <div class="text-left ml-4">
                  [{{ $t($t('message.item' + member.item.slice(0, 1).toUpperCase() + member.item.slice(1))) }}
                  {{ $t(member.itemCategoryName) }}]
                  <div v-for="i in member.rentalItems" :key="'rental-item-' + i.item">{{ $t(i.name) }}</div>
                </div>
              </div>
            </div>
            <div class="reserveItem ml-4"><span v-if="this.feePrice > 0 || insuranceTotal > 0"><small>{{ $t('小計') }}</small>￥{{ priceTotal }}<span v-if="this.feePrice > 0"> ＋ <small>({{ $t(feeNameKey) }})</small>￥{{ numPeople * feePrice }}</span><span v-if="insuranceTotal > 0"> ＋ <small>({{ $t('message.item_insurance_name') }})</small>￥<span data-testid="step4_insurance_amount">{{ insuranceTotal }}</span></span>
              ＝ </span>{{ $t('合計') }} <strong class="amount_price" data-testid="step4_total_amount">¥{{ priceTotal + numPeople * feePrice + insuranceTotal }}</strong></div>

            <template v-if="this.$parent.$i18n.locale === 'ja'">
              <div class="row ml-1">
                <div class="modal-title card_title text-left mb-2">
                  <h5 class="modal-title card_title text-left mb-2">
                  次のページにてクレジットカード情報をご入力下さい。<br>
                  登録完了するとレンタルNo.が発行されます。
                  </h5>
                  <p style="color: red">
                    ※クレジットカード情報登録だけでは申し込み完了できませんのでご注意下さい。<br>
                    ※与信状況によっては登録できない場合があります。
                  </p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row ml-1"><h5 class="modal-title card_title text-left mb-2">
                {{ $t('クレジットカードご入力で') }}<br>{{ $t('レンタル商品事前お取り置き＆当日即お渡し') }}</h5></div>
              <div class="expire_attention ml-4">※{{ $t('実際の決済はレンタル当日に履行されます') }}<br>{{ $t('与信状況によっては当日決済できない場合もございます') }}
              </div>
            </template>

            <form :action="prepaidFormURL" method="post" id="payment-form">
              <div v-html="registerFormHTML"></div>
              <button id="prepaidButton" type="submit" class="btn btn-primary paybtn" >
                <template v-if="this.$parent.$i18n.locale === 'ja'">
                  {{ $t('金額合計') }}￥{{ priceTotal + numPeople * feePrice + insuranceTotal }}で予約する
                </template>
                <template v-else>
                  {{ $t('金額合計') }}￥{{ priceTotal + numPeople * feePrice + insuranceTotal }}{{ $t('をご予約') }}.
                </template>
              </button>
            </form>

            <div id="expire_error" class="justify-content-between align-items-end" style="display: none">
              <div id="expire_message">
                {{ $t('レンタル当日に有効期限が過ぎてしまうため') }}<br>
                {{ $t('このカードはご利用いただけません。') }}<br>
                {{ $t('別のカードをご使用いただくか') }}<br>
                {{ $t('予約のみを選択してください。') }}
              </div>
              <div id="expire_ok">
                <button class="btn btn-outline-danger" @click="expireConfirm">ok</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal1" tabindex="-1" role="dialog" aria-labelledby="label1" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="label1">{{ $t('ご予約詳細') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row mt-2 border bg-white" v-for="(member, index) in this.$root.$store.state.members"
                 :key="'member-'+index">
              <div class="col p-1">
                <strong class="mr-2">{{ member.last_name }} {{ member.first_name }}<template v-if="$root.$i18n.locale === 'ja'"> {{ $t('様') }}</template></strong>
                <div>
                  <small v-if="feePrice > 0">
                    <span class="text-info">￥{{ calcAmount(member) }}     +    {{ $t(feeNameKey) }}¥{{ feePrice }}</span>
                  </small>
                </div>
              </div>
              <div class="col p-1">
                <div class="text-left ml-4">
                  <small>
                    <span class="text-info">{{ $t($t('message.age' + member.age)) }}</span>&nbsp;/
                    <span class="text-info">{{ member.height }} cm</span>&nbsp;/
                    <span class="text-info">{{ shoeFormatted(member.shoe) }}</span>&nbsp;
                  </small>
                </div>
                <div class="text-left ml-4">
                  [{{ $t($t('message.item' + member.item.slice(0, 1).toUpperCase() + member.item.slice(1))) }}
                  {{ $t(member.itemCategoryName) }}]
                  <div v-for="i in member.rentalItems" :key="'rental-item-' + i.item">{{ i.name }}</div>
                </div>
              </div>
            </div>
            <div class="reserveItem"><small>{{ $t('小計') }}</small>￥{{ priceTotal }} ＋ <small>({{ $t(feeNameKey) }})</small>￥{{ numPeople * feePrice }}<span v-if="insuranceTotal > 0"> ＋ <small>({{ $t('message.item_insurance_name') }})</small>￥{{ insuranceTotal }}</span>
              ＝ {{ $t('合計') }} <strong class="amount_price" data-testid="prepaid_total_amount">¥{{ priceTotal + numPeople * feePrice + insuranceTotal }}</strong></div>
            <div class="row"><h5 class="modal-title card_title text-left mb-2">
              {{ $t('クレジットカードご入力で') }}<br>{{ $t('レンタル商品事前お取り置き＆当日即お渡し') }}</h5></div>
            <div class="expire_attention">※{{ $t('実際の決済はレンタル当日に履行されます') }}<br>{{ $t('与信状況によっては当日決済できない場合もございます') }}
            </div>
            <form action="charge.php" method="post" id="payment-form">

              <div id="card-element"></div>
              <div id="card-errors" ref="cardErrors" role="alert"></div>
              <button id="payButton" type="submit" class="btn btn-primary paybtn"
                      :disabled='!complete'>{{ $t('金額合計') }}￥{{ priceTotal + numPeople * feePrice + insuranceTotal }}{{ $t('をご予約') }}
              </button>

            </form>
            <div id="expire_error" class="justify-content-between align-items-end">
              <div id="expire_message">
                {{ $t('レンタル当日に有効期限が過ぎてしまうため') }}<br>
                {{ $t('このカードはご利用いただけません。') }}<br>
                {{ $t('別のカードをご使用いただくか') }}<br>
                {{ $t('予約のみを選択してください。') }}
              </div>
              <div id="expire_ok">
                <button class="btn btn-outline-danger" @click="expireConfirm">ok</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal-square" tabindex="-1" role="dialog" aria-labelledby="label-square" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="label-square">{{ $t('ご予約詳細') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row mt-2 border bg-white" v-for="(member, index) in this.$root.$store.state.members"
                 :key="'member-square-'+index">
              <div class="col p-1">
                <strong class="mr-2">{{ member.last_name }} {{ member.first_name }}<template v-if="$root.$i18n.locale === 'ja'"> {{ $t('様') }}</template></strong>
                <div>
                  <small v-if="feePrice > 0">
                    <span class="text-info">￥{{ calcAmount(member) }}     +    {{ $t(feeNameKey) }}¥{{ feePrice }}</span>
                  </small>
                </div>
              </div>
              <div class="col p-1">
                <div class="text-left ml-4">
                  <small>
                    <span class="text-info">{{ $t($t('message.age' + member.age)) }}</span>&nbsp;/
                    <span class="text-info">{{ member.height }} cm</span>&nbsp;/
                    <span class="text-info">{{ shoeFormatted(member.shoe) }}</span>&nbsp;
                  </small>
                </div>
                <div class="text-left ml-4">
                  [{{ $t($t('message.item' + member.item.slice(0, 1).toUpperCase() + member.item.slice(1))) }}
                  {{ $t(member.itemCategoryName) }}]
                  <div v-for="i in member.rentalItems" :key="'rental-item-square-' + i.item">{{ i.name }}</div>
                </div>
              </div>
            </div>
            <div class="reserveItem"><small>{{ $t('小計') }}</small>￥{{ priceTotal }} ＋ <small>({{ $t(feeNameKey) }})</small>￥{{ numPeople * feePrice }}<span v-if="insuranceTotal > 0"> ＋ <small>({{ $t('message.item_insurance_name') }})</small>￥{{ insuranceTotal }}</span>
              ＝ {{ $t('合計') }} <strong class="amount_price" data-testid="prepaid_total_amount">¥{{ priceTotal + numPeople * feePrice + insuranceTotal }}</strong></div>
            <div class="row"><h5 class="modal-title card_title text-left mb-2">
              {{ $t('クレジットカードご入力で') }}<br>{{ $t('レンタル商品事前お取り置き＆当日即お渡し') }}</h5></div>
            <div class="expire_attention">※{{ $t('実際の決済はレンタル当日に履行されます') }}<br>{{ $t('与信状況によっては当日決済できない場合もございます') }}
            </div>
            <SquareCardForm v-if="squareFormVisible"
                            :application-id="$root.serviceSetting.square_application_id"
                            :location-id="$root.serviceSetting.square_location_id"
                            :environment="$root.serviceSetting.square_environment"
                            :locale="$root.$i18n.locale"
                            :buyer="buildSquareBuyer()"
                            :disabled="nowLoading === true"
                            @tokenized="onSquareTokenized">
              {{ $t('金額合計') }}￥{{ priceTotal + numPeople * feePrice + insuranceTotal }}{{ $t('をご予約') }}
            </SquareCardForm>
            <div id="square-card-errors" class="text-danger" role="alert" v-if="squareError">{{ $t(squareError) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
import SquareCardForm from './SquareCardForm.vue'
// import { loadStripe } from '@stripe/stripe-js'

export default {
  name: 'Register',
  components: { SquareCardForm },
  data () {
    return {
      times: [],
      timesFor: [],
      errors: {},
      showTimeSelect: false,
      willVisit: '',
      nowLoading: false,
      stripeLoading: false,
      stripe: null,
      card: null,
      complete: false,
      total: 0,
      stockOutDetail: [],
      stockOutHolder: '',
      stockOutSetFlag: true,
      stockout: false,
      stockoutObj: {},
      // metaData: '',
      numPeople: 0,
      feeCount: 0,
      feePrice: 0,
      enableV: true,
      enableS: true,
      feeCategoryId: 0,
      insurancePrice: 0,
      insuranceCategoryId: null,
      stripeError: {},
      prepaidFormURL: '',
      registerFormHTML: '',
      custCode: '',
      correctLoading: false,
      willVisitOff: false,
      texts: {
        willVisit: '',
        codeWillVisit: '01'
      },
      timeoutMessage: '',
      reloadStop: false,
      squareFormVisible: false,
      squareError: ''
    }
  },
  computed: {
    feeNameKey () {
      const ss = this.$root && this.$root.serviceSetting
      if (!ss || !ss.User || !ss.User.id) return '' // 安全策：必ず文字列を返す
      return 'message.' + ss.User.id + '.fee_name'
    },
    isTab () {
      return this.$root.$route.query.dev === 'tab'
    },
    isRad () {
      var isRad = false
      if (this.$root.$route.query.int && this.$root.$route.query.int.substr(-1) === '7') {
        isRad = true
      }
      return isRad
    },
    noticeReserveConfirmMessage () {
      let message = ''
      if (this.$root.serviceSetting && this.$root.serviceSetting.notice_reserve_confirm.value) {
        let int = this.$root.$route.query.int ? this.$root.$route.query.int : ''
        let messages = JSON.parse(this.$root.serviceSetting.notice_reserve_confirm.value)
        if (messages.introduce[int]) {
          message = messages.introduce[int]
        } else {
          message = messages.introduce['default']
        }
        var text = ''
        message.text.forEach(line => { text += this.$t(line) + '<br>' })
        return text
      }
      return null
    },
    priceTotal () {
      let m = this.$root.$store.state.members
      let total = 0
      m.forEach((t, index) => {
        let items = t.rentalItems
        if (parseInt(t.itemCategoryPrice) > 0) {
          total += parseInt(t.itemCategoryPrice)
        }
        if (items) {
          this.$_.each(items, function (item, index) {
            total += parseInt(item.price)
          })
        }
      })
      // this.total = total
      return total
    },
    insuranceTotal () {
      if (!this.$root.$store.state.itemInsurance) {
        return 0
      }
      return this.$root.$store.state.members.length * (this.insurancePrice || 0)
    },
    isZeroTotal () {
      return this.priceTotal + this.numPeople * this.feePrice + this.insuranceTotal <= 0
    },
    willVisitFrom () {
      let ret = ''
      let t = this.$root.$store.state.willVisit
      if (t && Object.keys(this.times).length > 0) {
        if (this.times[t]) {
          let tmp = this.times[t]
          let m = moment(tmp, 'HH:mm')
          ret = m.format('HH:mm')
        } else {
          ret = t
        }
      }
      return ret
    },
    willVisitTo () {
      let ret = ''
      let t = this.$root.$store.state.willVisit
      if (t && Object.keys(this.times).length > 0) {
        if (this.times[t]) {
          let tmp = this.times[t]
          let m = moment(tmp, 'HH:mm')
          ret = m.add(10, 'minutes').format('HH:mm')
        } else {
          ret = t
        }
      }
      return ret
    }
  },
  created () {
    // console.log('created')
    this.getEntryTime()

    this.getServiceSetting()
    this.willVisit = this.$root.$store.state.willVisit

    this.$nextTick(function () {
      this.setValues()
    })
  },
  async mounted () {
    // var publicKey = this.$root.$store.state.publicKey/
    // this.stripe = await loadStripe(publicKey)
    // const elements = this.stripe.elements()
    // var style = {
    //  base: {
    //    color: '#32325d',
    //    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    //    fontSmoothing: 'antialiased',
    //    fontSize: '16px',
    //    '::placeholder': {
    //      color: '#aab7c4'
    //    }
    //  },
    //  invalid: {
    //    color: '#fa755a',
    //    iconColor: '#fa755a'
    //  }
    // }
    // this.card = elements.create('card', { style: style, hidePostalCode: true })
    // this.card.mount('#card-element')
    // this.card.addEventListener('change', event => {
    //  if (event.error) {
    //    this.complete = false
    //    this.errorMessage = event.error.message
    //  } else {
    //    this.errorMessage = ''
    //    this.complete = true
    //  }
    // })
    window.sendGtag({
      'page_path': '/reserve-app/step4'
    })
    let c = this.$root.$route.query.c
    let h = this.$root.$route.query.h
    this.initText()
    if (c && h && c.length > 0 && h.length > 0 && c === this.$root.$store.state.custCode) {
      this.customer_id_stripe = this.custCode
      // location.hash = ''
      this.correctV()
    }
  },
  methods: {
    checkTime () {
      this.$root.$store.commit('update', { field: 'willVisit', value: this.$root.$store.state.willVisit })
      if (Object.keys(this.times).length === 0 || this.$root.$store.state.willVisit === '') {
        this.errors['willVisit'] = '受付日時が無効になっています'
      } else {
        delete (this.errors['willVisit'])
      }
    },
    getServiceSetting () {
      this.$emit('get-service-setting')
    },
    initText () {
      let jsonStr = JSON.parse(this.$root.serviceSetting.entry_time.value)
      if (jsonStr.visible) {
        if (jsonStr.visible === 'false') {
          console.log('willVisitOff')
          this.willVisitOff = true
        } else {
          this.willVisitOff = false
        }
      }
      // console.log('jsonStr', jsonStr)
      // console.log('p.name', jsonStr.name)
      // console.log('p.code', jsonStr.code)
      if (jsonStr.name) {
        this.texts.willVisit = jsonStr.name
      }
      if (jsonStr.code) {
        this.texts.codeWillVisit = jsonStr.code
      }
      return true
    },
    openPrepaidModal: function (e) {
      if (this.customer_id_stripe !== undefined && this.customer_id_stripe !== '') {
        this.correctV()
        return true
      }
      let url = this.$root.serviceSetting.serviceURL + '/reserve/api/prepaid_regist_form/'
      // 送信用データは store のコピーを使う。
      // store.state を参照のまま書き換えると store 本体が壊れる(下の selectOptions /
      // optionValues の代入が store にも及び、step1/step2 に戻ったときに
      // 選択肢が消える・optionValues 参照で落ちる)。
      let data = JSON.parse(JSON.stringify(this.$root.$store.state))
      data.selectOptions = null
      data.optionValues = null
      data.priceTotal = this.priceTotal + this.numPeople * this.feePrice + this.insuranceTotal

      data.introduce = this.$root.$route.query.int !== undefined
        ? this.$root.$route.query.int
        : (this.$root.$store.state.introduceCode || '')
      data.rentalType = this.$root.$route.query.type
      data.dev = this.$root.$route.query.dev
      data.v = true

      let _self = this
      axios.post(url, data)
        .then(response => {
          // console.log('response', response.data)
          _self.prepaidFormURL = response.data.url
          _self.registerFormHTML = response.data.html
          _self.custCode = response.data.custCode
          _self.$root.$store.commit('update', { field: 'custCode', value: response.data.cust_code })
          if (Object.keys(response.data.errors).length > 0) {
            _self.errors = response.data.errors
          } else {
            window.$('#modal-payment').modal('show')
          }
        }).catch(error => {
          console.log(error)
        }).finally(() => {
          _self.$root.$store.state.loading = false
          _self.calcFee()
        })
      return true
    },
    openSquareCardModal () {
      this.squareError = ''
      // v-if を一度落としてから立て直し、開くたびに SquareCardForm を作り直す（前回の card 要素を残さない）
      this.squareFormVisible = false
      this.$nextTick(() => {
        this.squareFormVisible = true
        window.$('#modal-square').modal('show')
      })
    },
    async onSquareTokenized (tok) {
      if (this.nowLoading) return
      this.nowLoading = true
      this.squareError = ''
      try {
        const url = this.$root.baseURL + 'square_regist_card.json'
        const reserveKey = this.$root.$store.state.email || ''
        const response = await axios.post(url, {
          nonce: tok.nonce,
          verificationToken: tok.verificationToken,
          reserveKey: reserveKey
        }, { headers: { 'Content-Type': 'application/json' }, responseType: 'json', timeout: 45000 })
        if (!response.data || !response.data.ok) {
          throw new Error((response.data && response.data.error) || 'card save failed')
        }
        this.$root.$store.commit('update', { field: 'square_card_ref', value: response.data.square_card_ref })
        window.$('#modal-square').modal('hide')
        this.squareFormVisible = false
        this.nowLoading = false // correctV/correctReserve が自前でローディングを管理するため、遷移前に解除
        this.correctV() // v=true で予約確定（addReserve に square_card_ref が乗る）
      } catch (e) {
        this.squareError = 'カードの登録に失敗しました。カード情報をご確認のうえ再度お試しください。'
        this.nowLoading = false
      }
    },
    buildSquareBuyer () {
      const st = this.$root.$store.state
      const m = (st.members && st.members[0]) ? st.members[0] : {}
      return {
        givenName: m.first_name || '',
        familyName: m.last_name || '',
        email: st.email || '',
        countryCode: st.country || 'JP',
        postalCode: st.zip || '',
        phone: st.tel || ''
      }
    },
    payment: async function (event) {
      this.complete = false
      // var rentalMouth = Number(this.$root.$store.state.rentalDateY) * 10 + Number(this.$root.$store.state.rentalDateM)
      event.preventDefault()
      // let self = this
      // this.stripe.createToken(this.card).then(function (result) {
      //   if (result.error) {
      //     var errorElement = document.getElementById('card-errors')
      //     errorElement.textContent = result.error.message
      //   } else {
      //     var expireMouth = result.token.card.exp_year * 10 + result.token.card.exp_month
      //     if (rentalMouth > expireMouth) {
      //       var target = document.getElementById('expire_error')
      //       target.style.display = 'flex'
      //       var focusElement = document.getElementById('card-element')
      //       focusElement.addEventListener('click', function clickEvent (event) {
      //         event.currentTarget.removeEventListener(event.type, clickEvent)
      //         self.expireConfirm()
      //       })
      //     } else {
      //       self.stripeTokenHandler(result.token)
      //     }
      //   }
      // })
    },
    expireConfirm () {
      document.getElementById('expire_error').style.display = 'none'
      this.card.clear()
      this.complete = false
    },
    stripeTokenHandler (token) {
      var stripe = {
        token: token.id,
        tel: this.$root.$store.state.tel,
        email: this.$root.$store.state.email,
        description: '',
        meta: {}
      }
      const itemNames = {
        snb: 'スノーボード',
        ski: 'スキー',
        ssk: 'ショートスキー'
      }
      let _self = this
      this.$root.$store.state.members.forEach(function (member, i) {
        var gear = itemNames[member.item] + (member.itemCategoryName || '単品')
        Object.keys(member.rentalItems).forEach(function (key) {
          gear += ' ' + member.rentalItems[key].name
        })
        gear = '[' + gear + ']'
        stripe.description += (i === 0 ? '' : ',') + gear
        let name = member.last_name + ' ' + member.first_name + '　様'
        let sex = member.sex === 'M' ? '男性' : '女性'
        let shoe = _self.shoeFormatted(member.shoe)
        let stance = member.stance || '左右無回答'
        stripe.meta[name] = {
          'サイズ': sex + ' / ' + member.age + '歳 / ' + member.height + 'cm / ' + shoe + ' / ' + stance,
          'ご要望': member.request || '未記入',
          '商品': gear,
          '金額': _self.calcAmount(member) + '円',
          '取置料': _self.feePrice + '円'
        }
      })
      this.$root.$store.commit('update', { field: 'stripe', value: stripe })
      this.$root.$store.commit('update', { field: 'v', value: true })
      window.$('body').removeClass('modal-open')
      window.$('.modal-backdrop').remove()
      window.$('#modal1').modal('hide')
      this.correctReserve()
    },
    // レンタルギア補償サービス #220
    // 会員登録トグルと同じ仕様に揃える(ダイナ 冨永さん指示)
    toggleItemInsurance (e) {
      const current = this.$root.$store.state.itemInsurance === true
      this.$root.$store.commit('update', { field: 'itemInsurance', value: !current })
    },
    toggleSaveMembership (e) {
      if (this.$root.$store.state.saveMembership === true) {
        this.$root.$store.commit('update', { field: 'saveMembership', value: false })
      } else {
        this.$root.$store.commit('update', { field: 'saveMembership', value: true })
      }
    },
    updateWillVisit (e) {
      // this.errors から willVisitを削除
      this.showTimeSelect = true
      delete (this.errors['willVisit'])
      this.$root.$store.commit('update', { field: 'willVisit', value: e.target.value })
      this.willVisit = e.target.value
    },
    getStockout (member) {
      return '<br>' + member.last_name + member.first_name
    },
    prepaidLimit () {
      let limit = moment(this.$root.$store.state.rentalDate + ' ' + this.$root.serviceSetting.limittime_time.value).subtract(1, 'days')
      let current = moment()
      if (this.$root.$route.query?.debug_day) {
        current = moment(this.$root.$route.query.debug_day)
      }
      // console.log('limit', limit.format('YYYY/MM/DD HH:mm:ss'))
      // console.log('current', current.format('YYYY/MM/DD HH:mm:ss'))

      return limit > current
    },
    calcFee () {
      let data = this.$root.$store.state
      let count = 0
      let peopleCount = 0
      data.members.forEach(member => {
        peopleCount++
        if (member.itemCategoryName) {
          count++
        }
        let items = member.rentalItems
        Object.keys(items).forEach(function (key) {
          count += items[key].num
        })
      })
      this.feeCount = peopleCount
      this.numPeople = peopleCount
      console.log('items', count)
    },
    calcAmount (member) {
      var price = member.itemCategoryPrice ? Number(member.itemCategoryPrice) : 0
      let items = member.rentalItems
      Object.keys(items).forEach(function (key) {
        price += Number(items[key].price)
      })
      return price
    },
    calcEachFee (member) {
      let items = member.rentalItems
      var count = 0
      if (member.itemCategoryName) count++
      Object.keys(items).forEach(function (key) {
        count += items[key].num
      })
      return count * this.feePrice
    },
    getEntryTime () {
      let d = this.$root.$store.state.rentalDateY + '-' + this.$root.$store.state.rentalDateM + '-' + this.$root.$store.state.rentalDateD
      let ui = this.$root.$route.query.ui ? this.$root.$route.query.ui : ''
      let int = this.$root.$route.query.int ? this.$root.$route.query.int : ''
      let debugDay = this.$root.$route.query.debug_day ? this.$root.$route.query.debug_day : ''
      let term = this.$root.$store.state.reserve_term
      let url = this.$root.baseURL + 'getEntryTime.json?d=' + d + '&ui=' + ui + '&type=' + int + '&term=' + term + '&debug_day=' + debugDay + '&ts=' + (new Date().getTime())
      axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      }).then(response => {
        this.times = {}
        this.timesFor = {}
        if (Object.keys(response.data.times).length > 0) {
          this.times = response.data.times
        }

        this.timesFor = {}
        if (Object.keys(response.data.timesFor).length > 0) {
          this.timesFor = response.data.timesFor
        }
        if (this.$root.$store.state.reserve_term && response.data.timesFor[this.$root.$store.state.reserve_term]) {
          this.times = response.data.timesFor[this.$root.$store.state.reserve_term]
        }

        this.feeCategoryId = response.data.fee_categoryId
        this.feePrice = parseInt(response.data.fee_price)
        this.$root.$store.commit('update', { field: 'feeCategoryId', value: response.data.fee_categoryId })
        this.$root.$store.commit('update', { field: 'feePrice', value: parseInt(response.data.fee_price) })
        this.insurancePrice = parseInt(response.data.insurance_price) || 0
        this.insuranceCategoryId = response.data.insurance_categoryId || null
        if (!this.$root.$store.state.willVisit) {
          let tmp = response.data.default
          this.$root.$store.commit('update', { field: 'willVisit', value: tmp })
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
        this.calcFee()
        this.checkTime()
      })
    },
    returnCart (e) {
      this.$root.$store.commit('update', { field: 'step', value: 3 })
    },
    correctV () {
      // console.log('correctV')
      this.$root.$store.commit('update', { field: 'stripe', value: {} })
      this.$root.$store.commit('update', { field: 'v', value: true })
      this.checkTime()
      this.correctReserve()
    },
    correctS () {
      // console.log('correctS')
      this.$root.$store.commit('update', { field: 'stripe', value: {} })
      this.$root.$store.commit('update', { field: 'v', value: false })
      this.checkTime()
      this.correctReserve()
    },
    correctReserve () {
      // console.log('correctReserve')
      this.nowLoading = true
      this.correctLoading = true
      let ui = this.$root.$route.query.ui ? this.$root.$route.query.ui : ''
      let queryInt = this.$root.$route.query.int || this.$root.$store.state.introduceCode || ''
      let type = this.$root.$route.query.type ? this.$root.$route.query.type : ''
      let dev = this.$root.$route.query.dev
      let url = this.$root.baseURL + 'addReserve.json?ts=' + (new Date().getTime())

      // 送信用データは store のコピーを使う。
      // store.state を参照のまま delete すると store 本体からキーが消え、
      // step1 に戻ったときに optionValues の参照で落ちる。
      let data = JSON.parse(JSON.stringify(this.$root.$store.state))

      delete data.optionValues
      // delete data.selectOptions
      delete data.reserveOpen
      delete data.reserveClose
      delete data.memberLimit
      delete data.loading
      delete data.publicKey

      data.ui = ui
      // 申込完了画面(Thanks)が store.ui を参照するため、store にも明示的に入れる。
      // これまでは data(=store の参照)への代入で暗黙に入っていた。
      this.$root.$store.commit('update', { field: 'ui', value: ui })
      // queryからintを取得
      data.int = queryInt
      // data.introduce があればそれを使う
      if (data.introduce && data.introduce.match(/^[0-9a-zA-Z]{3,}$/)) {
        data.int = data.introduce
      }
      data.type = type
      data.dev = dev
      // var dataMembers = data.members.slice()
      let _self = this
      /* if (data.v || (data.ui === '2' && !_self.isRad)) { // とりあえず (data.s && !this.isRad) を追加 */
      if (data.v) { // 除外をなくした
        // this.$_.each(dataMembers, (member, key) => {
        //   data.members[key].rentalItems.set_f = {
        //     'item': _self.$store.state.feeCategoryId,
        //     'name': '取置料',
        //     'num': 1,
        //     'price': _self.$store.state.feePrice
        //   }
        // })
      } else {
        data.members.forEach(member => {
          delete member.rentalItems.set_f
        })
        data.v = false
      }
      this.errors = []
      this.checkTime()
      // console.log('data', data)
      // console.log('this.$root.$store.state', this.$root.$store.state)
      axios.post(url, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'json',
        timeout: 45000
      }).then(response => {
        if (response.data.result === 'OK') {
          location.hash = ''
          // console.log('addReserve__OK')
          this.$root.$store.commit('update', { field: 'step', value: 5 })
          this.$root.$store.commit('update', { field: 'reserveId', value: response.data.reserveId })
          this.$root.$store.commit('update', { field: 'reserveIdRow', value: response.data.reserveIdRow })
          this.$root.$store.commit('update', { field: 'reserveIdShort', value: response.data.reserveIdShort })
          this.$root.$store.commit('update', { field: 'myPageHash', value: response.data.myPageHash })
        } else {
          // console.log('addReserve__失敗', data.members)
          data.members.forEach(member => {
            delete member.rentalItems.set_f
          })
          _self.errors = response.data.errors
          if (_self.errors.outOfStock) {
            _self.stockFormatted(response.data)
          }
          _self.stripeError = response.data.stripeError
          this.nowLoading = false
          this.correctLoading = false

          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        }
      }).catch(error => {
        if (error.code === 'ECONNABORTED') {
          // urlパラメータ〜にリトライ回数を加える
          let url = window.location.href
          let retry = 0
          if (url.match(/retry=\d+/)) {
            retry = parseInt(url.match(/retry=(\d+)/)[1])
          } else {
            url += (url.match(/\?/) ? '&' : '?') + 'retry=0'
          }
          retry++
          if (retry <= 5) {
            _self.timeoutMessage = '接続がタイムアウトしました。<br>画面をリロードします<br>The connection timed out. Reload the screen'
            setTimeout(function () {
              window.location.replace(url.replace(/retry=\d+/, 'retry=' + retry))
            }, 3000)
          } else {
            _self.reloadStop = true
            _self.timeoutMessage = '接続がタイムアウトしました。しばらくしてから再度お試しください<br>The connection timed out. Please try again later'
            // retryを外したurl
            url = url.replace(/&?retry=\d+/, '')
            _self.timeoutMessage += '<br><a href="' + url + '" class="btn btn-primary mt-3">リトライする<br>Retry</a>'
          }
        } else {
          console.log('addReserve__エラー', error)
          _self.reloadStop = true
          _self.timeoutMessage = '予約が完了できませんでした。しばらくしてから再度お試しください。<br>Failed to complete reservation. Please try again later.'
        }
        this.nowLoading = false
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }).finally(() => {
        this.$root.$store.state.loading = false
      })
      return false
    },
    stockFormatted (array) {
      var name = ''
      var value
      Object.keys(array.outOf_stocks).forEach(function (key) {
        name = key
        value = array.outOf_stocks[key][0]
      })
      this.stockOutHolder = name
      this.stockOutDetail = value
      this.stockOutSetFlag = value.set_flag
    },
    shoeFormatted (val) {
      let v = parseInt(val)
      if (v > 0) {
        return (v / 10).toFixed(1) + ' cm'
      }
      return null
    },
    // getStoreData
    debugStore () {
      console.log(this.$root.$store.state)
    },
    setValues () {
      // console.log('setValues')
      // console.log(this.$root.serviceSetting.enable_type_s)
      // console.log(this.$root.serviceSetting.enable_type_v)
      // let typeV = true
      // let typeS = true
      // if (this.$root.$store.state.optionValues) {
      //   typeV = this.$root.$store.state.optionValues.enableTypeV.value
      //   typeS = this.$root.$store.state.optionValues.enableTypeS.value
      // }
      this.enableV = this.$root.serviceSetting.enable_type_v.value === 'true'
      this.enableS = this.$root.serviceSetting.enable_type_s.value === 'true'
      if (this.$root.serviceSetting.enable_type_v && this.$root.$route.query.type === 'V') {
        this.enableV = true
        this.enableS = false
      }
      if (this.$root.serviceSetting.enable_type_s && this.$root.$route.query.type === 'S') {
        this.enableS = true
        this.enableV = false
      }
      console.log('ena', this.enableV, this.enableS)
    }
  }
}
</script>

<style scoped>
/* レンタルギア補償サービス #220
   会員登録はページ背景と同色にして目立たせず、補償サービスだけ白ボックスで見せる
   (ダイナ 冨永さん指示)。施設ごとに背景色が違っても追随するよう transparent にする
   チェックボックスの文言は太字+拡大(高鷲SP 大城さん指示) */
.form-box-gray {
  background-color: transparent;
}

.insurance-label {
  font-weight: bold;
  font-size: 1.3rem;
}

.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0 7px 14px 0 rgba(49,49,93,0.10),0 3px 6px 0 rgba(0,0,0,0.08);
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.modal-header {
    border-style: none;
    padding-bottom: 0;
}
.modal-content {
    background-color: #E6EBF1;
}
.paybtn {
  width: 100%;
  box-shadow: 0 7px 14px 0 rgba(49,49,93,0.10),0 3px 6px 0 rgba(0,0,0,0.08);
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
  margin-top: 20px;
}
.reserveItem {
    text-align: left;
    padding: 1.5rem 0;
    border-bottom: 1px solid #c7cbcf;
}
.card_title, #payment-form {
  padding: 1rem;
}
.card_title {
  padding-bottom: 0;
}
.btn.disabled, .btn:disabled {
    opacity: .3;
}
#expire_error{
    display: none;
}
#expire_message{
    text-align: left;
    color: red;
}
#expire_ok{
    text-align: right;
}
.expire_attention{
    text-align: left;
    font-size: 12px;
}
.stockout{
  color: red;
  font-weight: 700;
}
.amount_price{
  font-size: 24px;
}
.now-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.overlay-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 24px;
  font-weight: 700;
}
</style>
